/**
 * 合作伙伴滚动模块
 * 鼠标悬停暂停/恢复滚动，不足时自动复制元素
 */
export function initPartners() {
  const partnersTrack = document.querySelector('.partners-track');
  if (!partnersTrack) return;

  // 鼠标悬停暂停滚动
  partnersTrack.addEventListener('mouseenter', () => {
    partnersTrack.style.animationPlayState = 'paused';
  });

  // 鼠标离开恢复滚动
  partnersTrack.addEventListener('mouseleave', () => {
    partnersTrack.style.animationPlayState = 'running';
  });

  // 确保有足够的合作伙伴 logo 用于无缝滚动
  const partnerItems = document.querySelectorAll('.partner-item');
  const uniquePartnerCount = partnerItems.length / 2; // 已复制一组

  // 如果原始项目少于 4 个，再复制一些确保滚动流畅
  if (uniquePartnerCount < 4) {
    for (let i = 0; i < uniquePartnerCount; i++) {
      const clone = partnerItems[i].cloneNode(true);
      partnersTrack.appendChild(clone);
    }
  }
}
